

const Joi = require('joi');
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
// import * as Validator from "./BiddingCategory.Validator.js"

class BiddingCategoryAPI {


/*
undefinedPOST http://localhost:3000/biddingCategories/create
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "projectId" : "680119331235",
    "name" : "Bố trí nội thất",
    "typeOfBid":"public",
    "preferredCurrency":"VND",
    "bidOpenTime":"2018-03-25T00:10:23.754Z",
    "bidCloseTime":"2018-05-25T00:10:23.754Z",
    "allowAlternativeBids":true,
    "allowSealedBids":true,
    "documents":[{"id":"file-1","url":"Duong dan toi file"}]
}


*/    


  create = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/biddingCategories/create", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*


POST http://localhost:3000/biddingCategories/list
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "projectId" : "680119331235"
}

*/    


  list = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/biddingCategories/list", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*


POST http://localhost:3000/biddingCategories/detail/418423524583
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{

}


*/    


  418423524583 = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/biddingCategories/detail/418423524583", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*



POST http://localhost:3000/biddingCategories/update
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "id":"101355584905",
    "projectId" : "680119331235",
    "updateByType":"project",
    "updateById":"680119331235",
    "allowSealedBids":false,
    "documents":[{"id":"file-1 update ","url":"Duong dan toi file upate"}]
}


*/    


  update = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/biddingCategories/update", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*


POST http://localhost:3000/projects/search
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "city":"Thành Phố Hà Nội",
    "projectType":"Hotel",
    "minBudget":1000000000,
    "maxBudget":10000000000,
    "minStartTime":"2018-03-25T00:10:23.754Z",
    "maxStartTime":"2018-04-25T00:10:23.754Z",
    "minFinishTime":"2019-03-25T00:10:23.754Z",
    "maxFinishTime":"2019-04-25T00:10:23.754Z"
}


*/    


  search = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/projects/search", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*

*/    

  adminList = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/biddingCategories/adminList", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  approve = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/biddingCategories/approve", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }
}
export default new BiddingCategoryAPI();



// WEBPACK FOOTER //
// ./src/services/biddingCategory/BiddingCategory.API.js